import "./PageIndex.scss"
import React from "react"
import {FloatingYearFilter} from "../cmp/year/FloatingYearFilter";
import {YearFilterDrawer} from "../cmp/year/YearFilterDrawer";
import {useUnitsState} from "../store/UnitsState";
import {ObjectCard} from "../cmp/ObjectCard";
import {TopRightNav} from "../cmp/header/TopRightNav";

export function PageIndex() {

  const state = useUnitsState()

  return <div id="app-storefront-index">
    <header>
      <h1>{state.company.name}</h1>
      <div data-component="TopRightNav"><TopRightNav/></div>
    </header>
    <main style={{"paddingBottom": "120px"}}>
      {state.objects.map(object => <ObjectCard key={object.id} object={object}/>)}
    </main>
    <div data-component="FloatingYearFilter"><FloatingYearFilter></FloatingYearFilter></div>
    <YearFilterDrawer/>
  </div>

}